export default {"src":"/_next/static/media/adidas.ce2545de.svg","height":168,"width":250,"blurWidth":0,"blurHeight":0};